import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppParametersService, BaseAppParameters } from '@immosky/types';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(
    private appParametersService: AppParametersService<BaseAppParameters>
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const newRequest = this.attachBasicAuthToHeader(request);
    return next.handle(newRequest);
  }

  private attachBasicAuthToHeader(
    request: HttpRequest<unknown>
  ): HttpRequest<unknown> {
    let headers = request.headers;

    headers = headers.append(
      'Authorization',
      `Basic ${btoa(this.appParametersService.get().apiBasicAuth)}`
    );

    return request.clone({
      headers: headers,
    });
  }
}
